import style from "./style.module.scss";
import { Link, useRouteMatch } from "react-router-dom";

function NewsItem({ order, data }) {

    const { url } = useRouteMatch();

    return (
        <Link to={`${url}/${(data?.path ?? "")}`} style={{ color: "inherit", textDecoration: "inherit" }}>
            <div className={style.news_item} >
                <div className={style.image_box} style={{ backgroundImage: `url("${data?.image ?? ""}")`, order: order }}></div>
                <div className={style.text_box}>
                    <div className={style.text}>
                        <div className={style.title}>{data?.title ?? ""}</div>
                        <div className={style.date}>{data?.date ?? ""}</div>
                        {(data?.subtitle !== undefined) && <div className={style.subtitle}>{data?.subtitle ?? ""}</div>}
                        {/* Sanitize first! or study and use another method like markdown-jsx <div className={style.text} dangerouslySetInnerHTML={{ __html: (data?.text ?? "") }}></div> */}

                        <div className={style.showmore}>LEES MEER</div>
                    </div>
                </div>
            </div>
        </Link>
    );
}

export default NewsItem;